export async function Retry<T>(
  callback: (retry?: number) => Promise<T> | T,
  errorMessage?: string,
  errorCallback?: (err: any) => any,
  maxRetries: number = 5,
): Promise<T> {
  let retry = 0;
  let error: any;
  while (retry < maxRetries) {
    try {
      retry++;
      return await callback(retry);
    } catch (err: any) {
      try {
        error = errorCallback ? await errorCallback(err) : err;
      } catch {
        error = err;
      }
      console.warn(
        `[Retry ${retry}/${maxRetries}] ${errorMessage || "Retry failed"}:`,
      );
      console.warn(error);
    }
  }
  throw error;
}
